export default class CalculateWidth {
    constructor($el) {
        this.$el = $el;
        this.$headerMenu = document.querySelector('[data-header-menu]').querySelector('ul');
        // this.fullWidth = this.$headerMenu.offsetWidth;
        // this.width = this.$el.offsetWidth;

        this.headerRect = this.$headerMenu.getBoundingClientRect();
        this.headerRight = this.headerRect.right;

        this.elRect = this.$el.getBoundingClientRect();
        this.elLeft = this.elRect.left;

        this.calculate = this.calculate.bind(this);

        this.calculate();
    }

    calculate() {
        const targetWidth = this.headerRight - this.elLeft;
        this.$el.style.width = Math.max(0, targetWidth) + 'px';
    }
}